document.addEventListener('DOMContentLoaded', () => {
  const root = document.documentElement;
  const currentPath = window.location.pathname;
  const browseUrlStorageKey = 'gachaStationLastBrowseUrl';
  const isBrowsePage = currentPath === '/' || currentPath.startsWith('/collections/');
  const isBlockedReturnPath = (path) => path === '/cart' || path.startsWith('/checkout') || path.startsWith('/products/');

  if (isBrowsePage) {
    const browseUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    window.sessionStorage?.setItem(browseUrlStorageKey, browseUrl);
  }

  document.querySelectorAll('[data-nav-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const targetId = button.getAttribute('aria-controls');
      const target = document.getElementById(targetId);
      const isOpen = button.getAttribute('aria-expanded') === 'true';

      button.setAttribute('aria-expanded', String(!isOpen));

      if (target) {
        target.hidden = isOpen;
      }

      root.classList.toggle('nav-open', !isOpen);
    });
  });

  document.querySelectorAll('[data-accordion-trigger]').forEach((button) => {
    button.addEventListener('click', () => {
      const accordionItem = button.closest('.accordion-item');
      const content = accordionItem?.querySelector('.accordion-content') || document.getElementById(button.getAttribute('aria-controls'));
      const isOpen = button.getAttribute('aria-expanded') === 'true';

      button.setAttribute('aria-expanded', String(!isOpen));

      if (content) {
        content.hidden = isOpen;
      }
    });
  });

  const normalizeToStep = (value, min, step) => {
    if (step <= 1) return Math.max(min, value);
    const safeValue = Math.max(min, value);
    const offset = safeValue - min;
    const snapped = min + Math.round(offset / step) * step;
    return Math.max(min, snapped);
  };

  document.querySelectorAll('[data-quantity-selector]').forEach((wrapper) => {
    const input = wrapper.querySelector('input[type="number"]');
    const buttons = wrapper.querySelectorAll('[data-quantity-button]');

    const syncQuantitySelector = () => {
      if (!input) return;

      const min = Number(input.min || 1);
      const step = Number(input.step || 1);
      const max = Number(input.max || 999999);
      const value = Math.min(max, normalizeToStep(Number(input.value || min), min, step));
      input.value = String(value);

      buttons.forEach((button) => {
        const delta = Number(button.dataset.quantityButton || 0);
        if (delta < 0) {
          button.disabled = value <= min;
        }
      });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        if (!input) return;

        const currentValue = Number(input.value || 1);
        const min = Number(input.min || 1);
        const step = Number(input.step || 1);
        const max = Number(input.max || 999);
        const direction = Number(button.dataset.quantityButton || 0);
        const delta = direction * step;
        const nextValue = Math.min(max, Math.max(min, currentValue + delta));

        input.value = String(nextValue);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        syncQuantitySelector();
      });
    });

    input?.addEventListener('change', syncQuantitySelector);
    syncQuantitySelector();
  });

  document.querySelectorAll('[data-media-thumbnail]').forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      const gallery = thumbnail.closest('[data-media-gallery]');
      if (!gallery) return;

      const activeId = thumbnail.dataset.mediaThumbnail;

      gallery.querySelectorAll('[data-media-slide]').forEach((slide) => {
        slide.hidden = slide.dataset.mediaSlide !== activeId;
      });

      gallery.querySelectorAll('[data-media-thumbnail]').forEach((item) => {
        item.setAttribute('aria-current', String(item === thumbnail));
      });
    });
  });

  document.querySelectorAll('[data-collection-filter-input]').forEach((input) => {
    const shell = input.closest('.card') || document;
    const collectionShell = input.closest('.collection-shell') || document;
    const button = shell.querySelector('[data-collection-filter-button]');
    const cards = collectionShell.querySelectorAll('[data-product-card]');

    if (!cards.length) return;

    const applyFilter = () => {
      const query = input.value.trim().toLowerCase();

      cards.forEach((card) => {
        const title = (card.getAttribute('data-product-title') || '').toLowerCase();
        card.hidden = query !== '' && !title.includes(query);
      });
    };

    button?.addEventListener('click', () => {
      applyFilter();
      input.focus();
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        applyFilter();
      }
    });
  });

  document.querySelectorAll('[data-continue-shopping-link]').forEach((link) => {
    const fallbackUrl = link.getAttribute('data-fallback-url') || '/collections/all';
    const savedBrowseUrl = window.sessionStorage?.getItem(browseUrlStorageKey);
    const referrer = document.referrer;

    if (savedBrowseUrl && !isBlockedReturnPath(savedBrowseUrl)) {
      link.setAttribute('href', savedBrowseUrl);
      return;
    }

    if (!referrer) {
      link.setAttribute('href', fallbackUrl);
      return;
    }

    try {
      const referrerUrl = new URL(referrer);
      const currentUrl = new URL(window.location.href);

      if (referrerUrl.origin !== currentUrl.origin || isBlockedReturnPath(referrerUrl.pathname)) {
        link.setAttribute('href', fallbackUrl);
        return;
      }

      link.setAttribute('href', `${referrerUrl.pathname}${referrerUrl.search}${referrerUrl.hash}`);
    } catch (error) {
      link.setAttribute('href', fallbackUrl);
    }
  });
});
